import React from 'react';
import { CheckIcon, LockIcon, DownloadIcon, InfinityIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { pricingIncludes, coverImage, checkoutUrl } from '../data/landing';
export function PricingSection() {
  return <section id="oferta" className="scroll-mt-6 bg-cream pb-16 md:pb-32" data-id="element-130" data-mp="1egxl3untem5m">
      <div className="mx-auto max-w-5xl px-4 sm:px-5 md:px-8" data-id="element-131" data-mp="1j9qp2gbglqgn">
        <div className="grid overflow-hidden rounded-3xl border-2 border-gold-soft bg-white shadow-[0_40px_100px_-40px_rgba(139,100,33,0.45)] md:grid-cols-[0.8fr_1.2fr]" data-id="element-132" data-mp="1nasnww1gs0i3">
          <div className="flex items-center justify-center bg-parchment p-6 md:p-10" data-id="element-133" data-mp="1sbq3d0v3agfw">
            <img src={coverImage} alt="Portada de El Poder de los Salmos" className="w-full max-w-[170px] rounded-xl shadow-[0_24px_50px_-20px_rgba(43,33,24,0.5)] sm:max-w-[220px] md:max-w-[260px]" data-id="element-134" data-mp="1x9huvtrto0jk" />
          </div>
          <div className="p-6 text-center sm:p-8 md:p-12 md:text-left" data-id="element-135" data-mp="7utkfy2skso6">
            <p className="text-xs font-black uppercase tracking-[0.18em] text-gold sm:text-sm" data-id="element-136" data-mp="1mh6j0uul2u3c">Tu pack digital completo</p>
            <h2 className="mt-2 font-serif text-[1.65rem] font-semibold leading-tight text-ink sm:mt-3 sm:text-3xl md:text-4xl" data-id="element-137" data-mp="1howwlosogc5t">
              El Poder de los Salmos + 3 bonos exclusivos
            </h2>

            <div className="mt-5 flex items-end justify-center gap-3 sm:mt-6 sm:gap-4 md:justify-start" data-id="element-138" data-mp="17t3bvi4t1ccy">
              <span className="pb-1.5 text-base text-muted line-through sm:pb-2 sm:text-xl" data-id="element-139" data-mp="25e7n8dgbcq68">US$39,99</span>
              <span className="font-serif text-5xl font-bold leading-none text-gold-dark sm:text-6xl md:text-7xl" data-id="element-140" data-mp="20gz5gdz2uo5i">
                US$14,99
              </span>
            </div>
            <p className="mt-2 text-sm font-bold text-ink sm:text-base" data-id="element-141" data-mp="1repyfy30pcwv">Un solo pago · Pagas en la Moneda de tu Pais </p>

            <ul className="mt-6 space-y-2.5 text-left sm:mt-7 sm:space-y-3" data-id="element-142" data-mp="k3r2oi9h94an">
              {pricingIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm text-ink/85 sm:text-base" data-id="element-143" data-mp="g2yuztg977gh">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold" data-id="element-144" data-mp="hfx4f97lgneb">
                    <CheckIcon className="h-3.5 w-3.5 text-white" strokeWidth={3} aria-hidden="true" data-id="element-145" data-mp="7ju50b44n2v2" />
                  </span>
                  {item}
                </li>)}
            </ul>

            <CtaButton href={checkoutUrl} size="lg" className="mt-7 sm:mt-9 sm:w-full" data-id="element-146" data-mp="3uw4mcn90uakf">
              Sí, quiero mi pack completo
            </CtaButton>

            <ul className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-2 text-xs text-muted sm:mt-5 sm:gap-x-5 sm:text-sm" data-id="element-147" data-mp="3jbd6h28hwsv">
              <li className="flex items-center gap-1.5" data-id="element-148" data-mp="3pxl1kq65z4tn">
                <LockIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-149" data-mp="3py30xvo4hz5s" /> Pago seguro
              </li>
              <li className="flex items-center gap-1.5" data-id="element-150" data-mp="3bylkc3kzds7i">
                <DownloadIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-151" data-mp="3fzncy1ke760i" /> Entrega digital
              </li>
              <li className="flex items-center gap-1.5" data-id="element-152" data-mp="2xbwc9dcny6pi">
                <InfinityIcon className="h-4 w-4 text-gold" aria-hidden="true" data-id="element-153" data-mp="2sc0azlvcotdn" /> Acceso para volver a consultar
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}